module.exports = __webpack_public_path__ + "media/images/emblems/Landquart-coat_of_arms-dcd21ca31dfe5f703da88780f57069d9.svg";